import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { FieldConfig, RegFieldConfig } from '../../models/field.interface';
@Component({
  exportAs: 'dynamicForm',
  selector: 'mrsoftapps-stepper-dynamic-form',
  templateUrl: './stepper-dynamic-form.component.html',
  styleUrls: ['./stepper-dynamic-form.component.scss'],
})
export class StepperDynamicFormComponent implements OnChanges {
  @Input() fields: RegFieldConfig[] = [];
  @Input() student: any;

  @Output() submit: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;
  activedStep = 0;

  get value() {
    return this.form.value;
  }
  constructor(private fb: FormBuilder) {}

  // ngOnInit() {

  // }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fields.currentValue) {
      this.form = this.createControl();
      if (this.student) {
        this.form.patchValue(this.student);
      }
    }
  }

  onSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.form.valid) {
      this.submit.emit(this.form.value);
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  createControl() {
    const group = this.fb.group({});
    this.fields.forEach((item) => {
      // console.log('this is the fields ', item);
      return item.fields.forEach((field) => {
        if (field.type === 'button') return;
        const control = this.fb.control(
          field.value,
          this.bindValidations(field.validations || [])
        );
        group.addControl(field.name, control);
        // console.log('this is the fields ', group);
      });
    });
    // console.log('this is the fields ', this.fields);
    return group;
  }

  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach((valid) => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  prevStep(step) {
    this.activedStep = step - 1;
  }

  nextStep(step) {
    this.activedStep = step + 1;
  }
}
